import paths from "../../api/paths.api";
import CompanyForm from "../../pages/client/CompanyForm";
import ProjectPage from "../../pages/client/Project/ProjectPage";
// import EquipmentsPage from "../../pages/client/Project/ProjectPage/ProjectNestedPages/EquipmentsPage";

import MainProjects from "../../pages/client/Project/allProjectsPage";
import ProjectForm from "../../pages/client/Project/ProjectForm";
import EquipForm from "../../pages/client/Project/ProjectForm/EquipsForm";

import EquipmentPage from "../../pages/client/EquipmentPage";

// Equipment types
import MainPipe from "../../pages/client/AllEquipments/Piping";
import MainStructure from "../../pages/client/AllEquipments/Structural";
import MainInstrument from "../../pages/client/AllEquipments/Instrumentation";
import MainSkidPackage from "../../pages/client/AllEquipments/SkidPackage";
import MainPressureVessel from "../../pages/client/AllEquipments/PressureVessel";
import TankMain from "../../pages/client/AllEquipments/Tank/Main";
import MaterialsDBPage from "../../pages/client/MaterialsDBPage";
import SCM from "../../pages/client/SCMPage";
import SoftwarePage from "../../pages/client/SoftwarePage";
import SolutionPage from "../../pages/client/Solutions";
import ProjectTasksPage from "../../pages/client/Project/allProjectsPage/ProjectsTable/ProjectTasksPage";
import { DCSProvider } from "../../pages/client/AllEquipments/CommonFeatures/DCSTab/Table/DCSContext";
import OnboardingPage from "../../pages/client/OnboardingPage";
import { GeneralProvider } from "../../pages/client/AllEquipments/CommonFeatures/SidePanel/GeneralContext";
import ClientDataEditingPage from "../../pages/client/AllEquipments/CommonFeatures/SidePanel/TablesTab/ClientDataEditingPage";
import { AmsPage } from "../../pages/client/Ams";
// PlantsTable (the old "Project" landing grid) is left in place but no
// longer routed - ProjectLanding (below) replaced it at paths.myProjects so
// the sidebar tree is the way in instead. Swap the import/element back here
// if it's needed again.
import ProjectLanding from "../../pages/client/Project/ProjectLanding";
import ProjectHub from "../../pages/client/Project/plant/ProjectHub";
import MCSPage from "../../pages/client/AllEquipments/CommonFeatures/MCS3";
import CMSPage from "../../pages/client/AllEquipments/CommonFeatures/CMS";
import ValidationPage from "../../pages/client/AllEquipments/CommonFeatures/ValidationPage";
import EstimationTab2 from "../../pages/client/AllEquipments/CommonFeatures/EstimationTab2";
import EmsExplorerPage from "../../pages/client/AllEquipments/CommonFeatures/DCSTab/EmsExplorer";
import MRQPage from "../../pages/client/AllEquipments/CommonFeatures/MCS3/PMSTreeComponents/MRQPage";
import VendorBidEvaluationPage from "../../pages/client/AllEquipments/CommonFeatures/MCS3/PMSTreeComponents/VendorBidEvaluationPage";
import POPage from "../../pages/client/AllEquipments/CommonFeatures/MCS3/PMSTreeComponents/POPage";
import MRVPage from "../../pages/client/AllEquipments/CommonFeatures/MCS3/PMSTreeComponents/MRVPage";
import SRVPage from "../../pages/client/AllEquipments/CommonFeatures/MCS3/PMSTreeComponents/SRVPage";
import { Navigate } from "react-router-dom";

export const mainRoutes = [
  {
    path: paths.myProjects,
    element: <ProjectLanding />,
  },
  {
    path: paths.emsExplorer,
    element: <EmsExplorerPage />,
  },
  {
    path: paths.myEstimation,
    element: <EstimationTab2 />,
  },
  {
    path: paths.ams,
    element: <AmsPage />,
  },
  {
    path: `${paths.ams}/:id`,
    element: <AmsPage />,
  },

  {
    path: paths.plantMCS,
    element: (
      // <MCSContextProvider>
      <MCSPage plant />
      // </MCSContextProvider>
    ),
  },
  {
    path: paths.plantValidation,
    element: (
      // <MCSContextProvider>
      <ValidationPage plant />
      // </MCSContextProvider>
    ),
  },
  {
    path: paths.plantCMS,
    element: (
      // <MCSContextProvider>
      <CMSPage />
      // </MCSContextProvider>
    ),
  },
  {
    path: paths.plantMRQ,
    element: <MRQPage />,
  },
  {
    path: paths.plantVendorBidEvaluation,
    element: <VendorBidEvaluationPage />,
  },
  {
    path: paths.plantPO,
    element: <POPage />,
  },
  {
    path: paths.plantMRV,
    element: <MRVPage />,
  },
  {
    path: paths.plantSRV,
    element: <SRVPage />,
  },

  {
    path: paths.plantPage,
    element: <MainProjects />,
  },
  {
    path: paths.plantOpen,
    element: <ProjectHub />,
  },
  {
    path: paths.main_pv,
    element: <MainPressureVessel />,
  },
  {
    path: paths.main_pv_tabs,
    element: <MainPressureVessel />,
  },
  {
    path: paths.materialsDB,
    element: <MaterialsDBPage />,
  },
  {
    path: paths.clientVendors,
    element: (
      <GeneralProvider>
        <ClientDataEditingPage tab="structural" />
      </GeneralProvider>
    ),
  },
  {
    path: paths.scm,
    element: <SCM />,
  },
  {
    path: "/equipment/main_pv",
    element: <EquipmentPage />,
  },

  {
    path: paths.myMaterialRecords,
    element: (
      <Navigate to={`${paths.clientVendors}#editing-tables-main=Material`} replace />
    ),
  },
  {
    path: paths.projectFormApi,
    element: <ProjectForm />,
  },
  {
    path: paths.projectEquipsApi,
    element: <EquipForm />,
  },
  {
    path: paths.getAProject,
    element: <ProjectPage />,
    // children: [{ path: paths.EquipmentsApi, element: <EquipmentsPage /> }],
  },
  {
    path: paths.softwares,
    element: <SoftwarePage />,
  },
  {
    path: paths.onboarding,
    element: <OnboardingPage />,
  },
  {
    path: "/start-company",
    element: <CompanyForm />,
  },
  {
    path: "/projects/:id/equipments/main_tank",
    element: (
      <DCSProvider>
        <TankMain />
      </DCSProvider>
    ),
  },
  {
    path: "/projects/:id/equipments/piping",
    element: <MainPipe />,
  },
  {
    path: "/projects/:id/equipments/structural",
    element: <MainStructure />,
  },
  {
    path: "/projects/:id/equipments/instrumentation",
    element: <MainInstrument />,
  },
  {
    path: "/projects/:id/equipments/skid-package",
    element: <MainSkidPackage />,
  },
  {
    path: "/projects/:id/task",
    element: <ProjectTasksPage />,
  },
  {
    path: "/solutions",
    element: <SolutionPage />,
  },
];
